import React from 'react';
import {
  Typography, Stack,
} from '@mui/material';
import BaseModal from '../common/atoms/BaseModal/BaseModal';
import appStrings, { SUPPORT_MAILTO } from '../common/app_strings';

const AgeRestrictionModal = () => {
  const {
    ageRestricted: {
      title, body1, body2, ctaLabel,
    },
  } = appStrings;
  return (
    <BaseModal isOpen showExit={false} handleClose={() => { }}>
      <Stack
        sx={{
          padding: 2, justifyContent: 'center', alignItems: 'center', gap: 3,
        }}
      >
        <Typography sx={{ color: '#03295F', fontSize: '22px', fontWeight: 700 }}>{title}</Typography>
        <Typography>
          {body1}
          <br />
          <br />
          {body2}
        </Typography>
        <Typography
          component="a"
          href={SUPPORT_MAILTO}
          sx={{
            background: '#063D8F',
            color: 'white',
            borderRadius: '4px',
            padding: '12px 24px',
            textAlign: 'center',
            textDecoration: 'none',
            fontWeight: 700,
            marginBottom: 2,
            display: 'inline-block',
          }}
        >
          {ctaLabel}
        </Typography>
      </Stack>
    </BaseModal>
  );
};

export default AgeRestrictionModal;
